import React,{useRef, useEffect,Suspense} from 'react'
//import {Canvas,useFrame, extend, useThree, useLoader} from "react-three-fiber";
import * as THREE from 'three';
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls";
import { EffectComposer } from 'three/examples/jsm/postprocessing/EffectComposer';
import { RenderPass } from 'three/examples/jsm/postprocessing/RenderPass';
import { ShaderPass } from 'three/examples/jsm/postprocessing/ShaderPass';
import { FXAAShader } from 'three/examples/jsm/shaders/FXAAShader';
import { SAOPass } from 'three/examples/jsm/postprocessing/SAOPass.js';
import { Sky } from 'three/examples/jsm/objects/Sky.js';
import {useSelector} from "react-redux";
import {getDeltas,getMesh} from "../Helpers/functions";
import Node from '../Classes/Node'
import {FBXLoader} from "three/examples/jsm/loaders/FBXLoader";
import {
    resizeDoor,
    resizeWindow
} from "../Helpers/GeometryAlgoritm";
import {Vector2} from "three";

const ThreeScene = ({plan})=>{
    const modules = useSelector(store=>store.modules.modules);
    const canvas = useRef(null);


    useEffect(()=>{

        let windowModel = null;
        let doorModel = null;

        const onResize = ()=>{
            const width = canvas.current.clientWidth;
            const height = canvas.current.clientHeight;
            camera.aspect = width / height;
            camera.updateProjectionMatrix();
            renderer.setSize(width,height);
            //composer.setSize(width,height);
            //effectFXAA.uniforms['resolution'].value.set(1/width,1/height);
        }
        window.addEventListener("resize",onResize);
        var camera,scene,mouse = new THREE.Vector2(),controls,ambientLight,spotLight,renderer,raycaster,composer,rp,effectFXAA,saoPass,clock;

        const generateFloor = (plan,mat)=>{
            // console.log('generateFloor ',plan);
            const result = new THREE.Group();
            result.userData.type = "floor";

            plan.cycles.map(polygon=>{
                const perimetrV = [];
                //perimetrV.push(new THREE.Vector2(polygon.links[0].a.x/100,polygon.links[0].a.y/100))});
                polygon.points.map(point=>{perimetrV.push(new THREE.Vector2(point.x/100,point.y/100))});
                const perimetrT = THREE.ShapeUtils.triangulateShape(perimetrV,[]);
                const floor = new THREE.Geometry();
                perimetrV.map(point=>{
                    floor.vertices.push(new THREE.Vector3(point.x,0,point.y));
                });

                perimetrT.map((t,k)=>{
                    const face = new THREE.Face3(t[0],t[1],t[2],new THREE.Vector3(0.0,1.0,0.0));
                    floor.faces.push(face);
                    const uvs = [
                        new THREE.Vector2(floor.vertices[t[0]].x/4.000000001,floor.vertices[t[0]].z/4.000000001),
                        new THREE.Vector2(floor.vertices[t[1]].x/4.000000001,floor.vertices[t[1]].z/4.000000001),
                        new THREE.Vector2(floor.vertices[t[2]].x/4.000000001,floor.vertices[t[2]].z/4.000000001)
                    ];
                    floor.faceVertexUvs[0].push(uvs);
                });
                // const material = mat?mat:new THREE.MeshPhongMaterial();
                const material = polygon.material?polygon.material:new THREE.MeshPhongMaterial();
                const floorobj = new THREE.Mesh(new THREE.BufferGeometry().fromGeometry(floor), material );
                floorobj.receiveShadow = true;
                result.add(floorobj);
            });
            //милиметровка
            // const planGmt = new THREE.PlaneBufferGeometry(100,100,1,1);
            // planGmt.attributes.uv.array = planGmt.attributes.uv.array.map(p=>p*100);
            // const mm = new THREE.TextureLoader().load( '/configurator3d/img/mm.jpg',t=>{
            //     t.wrapS = THREE.RepeatWrapping;
            //     t.wrapT = THREE.RepeatWrapping;
            // } );

            /*
            const planGmt = new THREE.PlaneBufferGeometry(100,100,100,100);
            const planeMat = new THREE.MeshBasicMaterial({
                color:0xFFFFFF
            });
            const planeMesh = new THREE.Mesh( planGmt, planeMat );
            planeMesh.translateY(-0.03);
            planeMesh.rotateX(-Math.PI/2);
            planeMesh.receiveShadow = true;
            result.add(planeMesh);*/
            return result;
        };

        const generateWalls = (walls)=>{
            // console.log('generateWalls windowModel',windowModel)
            // console.log('generateWalls doorModel',doorModel)

            const result = new THREE.Group();
            result.name = 'walls';
            walls.map(wall=>{

                // console.log('generateWalls() wall',wall)

                const group = new THREE.Group();
                const wallVector = wall.b.clone().sub(wall.a);
                const angle = -wallVector.angle();
                // const center = wall.b.clone().add(wall.a).divideScalar(200);
                // const len = wallVector.length();

                const whiteMat = new THREE.MeshPhysicalMaterial({color:0xffffff})
                whiteMat.side = THREE.DoubleSide

                // Нарезка стены под окна/двери
                const wallSlicesPoints = []
                wall.objects.map(obj=>{
                    wallSlicesPoints.push({
                        rA1:obj.rA1,
                        rA2:obj.rA2,
                        rB1:obj.rB1,
                        rB2:obj.rB2,
                        pos:obj.pos,
                        width:obj.width,
                        height:obj.height,
                        heightFromFloor:obj.heightFromFloor,
                    })
                })
                // console.log('wallSlicesPoints',wallSlicesPoints)
                wallSlicesPoints.sort((a,b) => {
                    return a.pos - b.pos
                })
                // console.log('wallSlicesPoints',wallSlicesPoints)



                let side1Geometry, side2Geometry, polygonGeometry, uvs, bg1, bg2, __y, rB1, rB2
                const side3slopesGeometry = new THREE.Group(); /* Откосы */

                function setSide(a, b) {
                    side1Geometry = new THREE.Geometry();

                    const rB1 = a
                    const rB2 = b

                    side1Geometry.vertices.push(new THREE.Vector3(rB1.x/100,0.0,rB1.y/100));
                    side1Geometry.vertices.push(new THREE.Vector3(rB1.x/100,wall.height/100,rB1.y/100));
                    side1Geometry.vertices.push(new THREE.Vector3(rB2.x/100,0.0, rB2.y/100));
                    side1Geometry.vertices.push(new THREE.Vector3(rB2.x/100,wall.height/100,rB2.y/100));

                    side1Geometry.faces.push(new THREE.Face3(1,0,2,new THREE.Vector3(0.0,0.0,1.0)));
                    uvs = [
                        new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                        new THREE.Vector2(side1Geometry.vertices[0].x,side1Geometry.vertices[0].y),
                        new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                    ];

                    side1Geometry.faceVertexUvs[0].push(uvs);
                    side1Geometry.faces.push(new THREE.Face3(3,1,2,new THREE.Vector3(0.0,0.0,1.0)));
                    uvs = [
                        new THREE.Vector2(side1Geometry.vertices[3].x,side1Geometry.vertices[3].y),
                        new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                        new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                    ];
                    side1Geometry.faceVertexUvs[0].push(uvs);
                    bg1 = new THREE.BufferGeometry().fromGeometry( side1Geometry );

                    return side1Geometry
                }

                function setPolygon(a, b, c, d) { // создание прямоугольного полигона из двух треугольников
                    polygonGeometry = new THREE.Geometry();

                    polygonGeometry.vertices.push(new THREE.Vector3(a.x/100,a.z/100,a.y/100));
                    polygonGeometry.vertices.push(new THREE.Vector3(b.x/100,b.z/100,b.y/100));
                    polygonGeometry.vertices.push(new THREE.Vector3(c.x/100,c.z/100,c.y/100));
                    polygonGeometry.vertices.push(new THREE.Vector3(d.x/100,d.z/100,d.y/100));

                    polygonGeometry.faces.push(new THREE.Face3(0,1,2, new THREE.Vector3(0.0,0.0,1.0)));
                    uvs = [
                        new THREE.Vector2(polygonGeometry.vertices[0].x,polygonGeometry.vertices[0].y),
                        new THREE.Vector2(polygonGeometry.vertices[1].x,polygonGeometry.vertices[1].y),
                        new THREE.Vector2(polygonGeometry.vertices[2].x,polygonGeometry.vertices[2].y)
                    ];

                    polygonGeometry.faceVertexUvs[0].push(uvs);
                    polygonGeometry.faces.push(new THREE.Face3(2,3,1, new THREE.Vector3(0.0,0.0,-1.0)));
                    uvs = [
                        new THREE.Vector2(polygonGeometry.vertices[2].x,polygonGeometry.vertices[2].y),
                        new THREE.Vector2(polygonGeometry.vertices[3].x,polygonGeometry.vertices[3].y),
                        new THREE.Vector2(polygonGeometry.vertices[1].x,polygonGeometry.vertices[1].y)
                    ];
                    polygonGeometry.faceVertexUvs[0].push(uvs);
                    bg1 = new THREE.BufferGeometry().fromGeometry( polygonGeometry );

                    return polygonGeometry
                }

                if (wallSlicesPoints.length > 0) {
                    for (let i=0; i<wallSlicesPoints.length; i++) {

                        /* Откосы */
                        const topZ = (wallSlicesPoints[i].heightFromFloor*1+wallSlicesPoints[i].height*1)
                        const botZ = (wallSlicesPoints[i].heightFromFloor > 0) ? wallSlicesPoints[i].heightFromFloor : -1;
                        let a = {
                                x:wallSlicesPoints[i].rA1.x,
                                y:wallSlicesPoints[i].rA1.y,
                                z:topZ
                            },
                            b = {
                                x:wallSlicesPoints[i].rA2.x,
                                y:wallSlicesPoints[i].rA2.y,
                                z:topZ
                            },
                            c = {
                                x:wallSlicesPoints[i].rB1.x,
                                y:wallSlicesPoints[i].rB1.y,
                                z:topZ
                            },
                            d = {
                                x:wallSlicesPoints[i].rB2.x,
                                y:wallSlicesPoints[i].rB2.y,
                                z:topZ
                            },
                            a1 = {
                                x:wallSlicesPoints[i].rA1.x,
                                y:wallSlicesPoints[i].rA1.y,
                                z:botZ
                            },
                            b1 = {
                                x:wallSlicesPoints[i].rA2.x,
                                y:wallSlicesPoints[i].rA2.y,
                                z:botZ
                            },
                            c1 = {
                                x:wallSlicesPoints[i].rB1.x,
                                y:wallSlicesPoints[i].rB1.y,
                                z:botZ
                            },
                            d1 = {
                                x:wallSlicesPoints[i].rB2.x,
                                y:wallSlicesPoints[i].rB2.y,
                                z:botZ
                            };

                        group.add(new THREE.Mesh(setPolygon(a, b, c, d), whiteMat));
                        group.add(new THREE.Mesh(setPolygon(a1, b1, c1, d1), whiteMat));
                        group.add(new THREE.Mesh(setPolygon(a, b, a1, b1), whiteMat));
                        group.add(new THREE.Mesh(setPolygon(c, d, c1, d1), whiteMat));
                        /* / Откосы */

                        if (i === 0) {
                            group.add(new THREE.Mesh(setSide(wall.rB1, wallSlicesPoints[i].rA2),wall.leftSide))
                            group.add(new THREE.Mesh(setSide(wallSlicesPoints[i].rA1, wall.rA1),wall.leftSide))
                        }

                        if (i === wallSlicesPoints.length-1) {
                            group.add(new THREE.Mesh(setSide(wallSlicesPoints[i].rB2, wall.rB2),wall.leftSide))
                            group.add(new THREE.Mesh(setSide(wall.rA2, wallSlicesPoints[i].rB1),wall.leftSide))
                        } else {
                            group.add(new THREE.Mesh(setSide(wallSlicesPoints[i].rB2, wallSlicesPoints[i+1].rA2),wall.leftSide))
                            group.add(new THREE.Mesh(setSide(wallSlicesPoints[i+1].rA1, wallSlicesPoints[i].rB1),wall.leftSide))
                        }



                        __y = (wallSlicesPoints[i].heightFromFloor*1+wallSlicesPoints[i].height*1)/100

                        if(__y < wall.height/100) {
                            side1Geometry = new THREE.Geometry();

                            rB1 = wallSlicesPoints[i].rB1
                            rB2 = wallSlicesPoints[i].rA1

                            side1Geometry.vertices.push(new THREE.Vector3(rB1.x/100,__y,rB1.y/100));
                            side1Geometry.vertices.push(new THREE.Vector3(rB1.x/100,wall.height/100,rB1.y/100));
                            side1Geometry.vertices.push(new THREE.Vector3(rB2.x/100,__y, rB2.y/100));
                            side1Geometry.vertices.push(new THREE.Vector3(rB2.x/100,wall.height/100,rB2.y/100));

                            side1Geometry.faces.push(new THREE.Face3(1,0,2,new THREE.Vector3(0.0,0.0,1.0)));
                            uvs = [
                                new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                                new THREE.Vector2(side1Geometry.vertices[0].x,side1Geometry.vertices[0].y),
                                new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                            ];

                            side1Geometry.faceVertexUvs[0].push(uvs);
                            side1Geometry.faces.push(new THREE.Face3(3,1,2,new THREE.Vector3(0.0,0.0,1.0)));
                            uvs = [
                                new THREE.Vector2(side1Geometry.vertices[3].x,side1Geometry.vertices[3].y),
                                new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                                new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                            ];
                            side1Geometry.faceVertexUvs[0].push(uvs);
                            bg1 = new THREE.BufferGeometry().fromGeometry( side1Geometry );
                            group.add(new THREE.Mesh(bg1,wall.leftSide));


                            side1Geometry = new THREE.Geometry();

                            rB1 = wallSlicesPoints[i].rA2
                            rB2 = wallSlicesPoints[i].rB2

                            side1Geometry.vertices.push(new THREE.Vector3(rB1.x/100,__y,rB1.y/100));
                            side1Geometry.vertices.push(new THREE.Vector3(rB1.x/100,wall.height/100,rB1.y/100));
                            side1Geometry.vertices.push(new THREE.Vector3(rB2.x/100,__y, rB2.y/100));
                            side1Geometry.vertices.push(new THREE.Vector3(rB2.x/100,wall.height/100,rB2.y/100));

                            side1Geometry.faces.push(new THREE.Face3(1,0,2,new THREE.Vector3(0.0,0.0,1.0)));
                            uvs = [
                                new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                                new THREE.Vector2(side1Geometry.vertices[0].x,side1Geometry.vertices[0].y),
                                new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                            ];

                            side1Geometry.faceVertexUvs[0].push(uvs);
                            side1Geometry.faces.push(new THREE.Face3(3,1,2,new THREE.Vector3(0.0,0.0,1.0)));
                            uvs = [
                                new THREE.Vector2(side1Geometry.vertices[3].x,side1Geometry.vertices[3].y),
                                new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                                new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                            ];
                            side1Geometry.faceVertexUvs[0].push(uvs);
                            bg1 = new THREE.BufferGeometry().fromGeometry( side1Geometry );
                            group.add(new THREE.Mesh(bg1,wall.leftSide));
                        }


                        if (wallSlicesPoints[i].heightFromFloor > 0) {
                            __y = wallSlicesPoints[i].heightFromFloor/100

                            side1Geometry = new THREE.Geometry();

                            rB1 = wallSlicesPoints[i].rB1
                            rB2 = wallSlicesPoints[i].rA1

                            side1Geometry.vertices.push(new THREE.Vector3(rB1.x/100,0.0,rB1.y/100));
                            side1Geometry.vertices.push(new THREE.Vector3(rB1.x/100,__y,rB1.y/100));
                            side1Geometry.vertices.push(new THREE.Vector3(rB2.x/100,0.0, rB2.y/100));
                            side1Geometry.vertices.push(new THREE.Vector3(rB2.x/100,__y,rB2.y/100));

                            side1Geometry.faces.push(new THREE.Face3(1,0,2,new THREE.Vector3(0.0,0.0,1.0)));
                            uvs = [
                                new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                                new THREE.Vector2(side1Geometry.vertices[0].x,side1Geometry.vertices[0].y),
                                new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                            ];

                            side1Geometry.faceVertexUvs[0].push(uvs);
                            side1Geometry.faces.push(new THREE.Face3(3,1,2,new THREE.Vector3(0.0,0.0,1.0)));
                            uvs = [
                                new THREE.Vector2(side1Geometry.vertices[3].x,side1Geometry.vertices[3].y),
                                new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                                new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                            ];
                            side1Geometry.faceVertexUvs[0].push(uvs);
                            bg1 = new THREE.BufferGeometry().fromGeometry( side1Geometry );
                            group.add(new THREE.Mesh(bg1,wall.leftSide));


                            side1Geometry = new THREE.Geometry();

                            rB1 = wallSlicesPoints[i].rA2
                            rB2 = wallSlicesPoints[i].rB2

                            side1Geometry.vertices.push(new THREE.Vector3(rB1.x/100,0.0,rB1.y/100));
                            side1Geometry.vertices.push(new THREE.Vector3(rB1.x/100,__y,rB1.y/100));
                            side1Geometry.vertices.push(new THREE.Vector3(rB2.x/100,0.0, rB2.y/100));
                            side1Geometry.vertices.push(new THREE.Vector3(rB2.x/100,__y,rB2.y/100));

                            side1Geometry.faces.push(new THREE.Face3(1,0,2,new THREE.Vector3(0.0,0.0,1.0)));
                            uvs = [
                                new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                                new THREE.Vector2(side1Geometry.vertices[0].x,side1Geometry.vertices[0].y),
                                new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                            ];

                            side1Geometry.faceVertexUvs[0].push(uvs);
                            side1Geometry.faces.push(new THREE.Face3(3,1,2,new THREE.Vector3(0.0,0.0,1.0)));
                            uvs = [
                                new THREE.Vector2(side1Geometry.vertices[3].x,side1Geometry.vertices[3].y),
                                new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                                new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                            ];
                            side1Geometry.faceVertexUvs[0].push(uvs);
                            bg1 = new THREE.BufferGeometry().fromGeometry( side1Geometry );
                            group.add(new THREE.Mesh(bg1,wall.leftSide));
                        }
                    }
                } else {

                    side1Geometry = new THREE.Geometry();

                    side1Geometry.vertices.push(new THREE.Vector3(wall.rB1.x/100,0.0,wall.rB1.y/100));
                    side1Geometry.vertices.push(new THREE.Vector3(wall.rB1.x/100,wall.height/100,wall.rB1.y/100));
                    side1Geometry.vertices.push(new THREE.Vector3(wall.rB2.x/100,0.0, wall.rB2.y/100));
                    side1Geometry.vertices.push(new THREE.Vector3(wall.rB2.x/100,wall.height/100,wall.rB2.y/100));

                    side1Geometry.faces.push(new THREE.Face3(1,0,2,new THREE.Vector3(0.0,0.0,1.0)));
                    uvs = [
                        new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                        new THREE.Vector2(side1Geometry.vertices[0].x,side1Geometry.vertices[0].y),
                        new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                    ];

                    side1Geometry.faceVertexUvs[0].push(uvs);
                    side1Geometry.faces.push(new THREE.Face3(3,1,2,new THREE.Vector3(0.0,0.0,1.0)));
                    uvs = [
                        new THREE.Vector2(side1Geometry.vertices[3].x,side1Geometry.vertices[3].y),
                        new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                        new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                    ];
                    side1Geometry.faceVertexUvs[0].push(uvs);
                    bg1 = new THREE.BufferGeometry().fromGeometry( side1Geometry );

                    /////////////////////////////////////////////////////////////////////////////////////////////////////
                    side2Geometry = new THREE.Geometry();

                    side2Geometry.vertices.push(new THREE.Vector3(wall.rA1.x/100,0.0,wall.rA1.y/100));
                    side2Geometry.vertices.push(new THREE.Vector3(wall.rA1.x/100,wall.height/100,wall.rA1.y/100));
                    side2Geometry.vertices.push(new THREE.Vector3(wall.rA2.x/100,0.0, wall.rA2.y/100));
                    side2Geometry.vertices.push(new THREE.Vector3(wall.rA2.x/100,wall.height/100,wall.rA2.y/100));

                    side2Geometry.faces.push(new THREE.Face3(0,1,2,new THREE.Vector3(0.0,0.0,1.0)));
                    uvs = [
                        new THREE.Vector2(side2Geometry.vertices[0].x,side2Geometry.vertices[0].y),
                        new THREE.Vector2(side2Geometry.vertices[1].x,side2Geometry.vertices[1].y),
                        new THREE.Vector2(side2Geometry.vertices[2].x,side2Geometry.vertices[2].y)
                    ];
                    side2Geometry.faceVertexUvs[0].push(uvs);

                    side2Geometry.faces.push(new THREE.Face3(1,3,2,new THREE.Vector3(0.0,0.0,1.0)));
                    uvs = [
                        new THREE.Vector2(side2Geometry.vertices[1].x,side2Geometry.vertices[1].y),
                        new THREE.Vector2(side2Geometry.vertices[3].x,side2Geometry.vertices[3].y),
                        new THREE.Vector2(side2Geometry.vertices[2].x,side2Geometry.vertices[2].y)
                    ];
                    side2Geometry.faceVertexUvs[0].push(uvs);
                    bg2 = new THREE.BufferGeometry().fromGeometry( side2Geometry );

                    group.add(new THREE.Mesh(bg1,wall.leftSide));
                    group.add(new THREE.Mesh(bg2,wall.rightSide));
                }


                //////////////////////////////////////////////////////////////////////////////////////////////////
                const side3Geometry = new THREE.Geometry();

                side3Geometry.vertices.push(new THREE.Vector3(wall.rA2.x/100,0.0, wall.rA2.y/100));             //0
                side3Geometry.vertices.push(new THREE.Vector3(wall.rB2.x/100,0.0, wall.rB2.y/100));             //1
                side3Geometry.vertices.push(new THREE.Vector3(wall.rA2.x/100,wall.height/100,wall.rA2.y/100));  //2
                side3Geometry.vertices.push(new THREE.Vector3(wall.rB2.x/100,wall.height/100,wall.rB2.y/100));  //3

                side3Geometry.vertices.push(new THREE.Vector3(wall.rA1.x/100,wall.height/100,wall.rA1.y/100));  //4
                side3Geometry.vertices.push(new THREE.Vector3(wall.rB1.x/100,wall.height/100,wall.rB1.y/100));  //5
                side3Geometry.vertices.push(new THREE.Vector3(wall.rA1.x/100,0.0,wall.rA1.y/100));              //6
                side3Geometry.vertices.push(new THREE.Vector3(wall.rB1.x/100,0.0,wall.rB1.y/100));              //7

                side3Geometry.vertices.push(new THREE.Vector3(wall.a.x/100,wall.height/100,wall.a.y/100));      //8
                side3Geometry.vertices.push(new THREE.Vector3(wall.b.x/100,wall.height/100,wall.b.y/100));      //9


                side3Geometry.faces.push(new THREE.Face3(0,3,1,new THREE.Vector3(-1.0,0.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[0].x,side3Geometry.vertices[0].y),
                    new THREE.Vector2(side3Geometry.vertices[3].x,side3Geometry.vertices[3].y),
                    new THREE.Vector2(side3Geometry.vertices[1].x,side3Geometry.vertices[1].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);

                side3Geometry.faces.push(new THREE.Face3(0,2,3,new THREE.Vector3(-1.0,0.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[0].x,side3Geometry.vertices[0].y),
                    new THREE.Vector2(side3Geometry.vertices[2].x,side3Geometry.vertices[2].y),
                    new THREE.Vector2(side3Geometry.vertices[3].x,side3Geometry.vertices[3].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);

                side3Geometry.faces.push(new THREE.Face3(2,4,3,new THREE.Vector3(0.0,1.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[2].x,side3Geometry.vertices[2].y),
                    new THREE.Vector2(side3Geometry.vertices[4].x,side3Geometry.vertices[4].y),
                    new THREE.Vector2(side3Geometry.vertices[3].x,side3Geometry.vertices[3].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);

                side3Geometry.faces.push(new THREE.Face3(3,4,5,new THREE.Vector3(0.0,1.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[3].x,side3Geometry.vertices[3].y),
                    new THREE.Vector2(side3Geometry.vertices[4].x,side3Geometry.vertices[4].y),
                    new THREE.Vector2(side3Geometry.vertices[5].x,side3Geometry.vertices[5].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);

                side3Geometry.faces.push(new THREE.Face3(4,6,7,new THREE.Vector3(1.0,0.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[4].x,side3Geometry.vertices[4].y),
                    new THREE.Vector2(side3Geometry.vertices[6].x,side3Geometry.vertices[6].y),
                    new THREE.Vector2(side3Geometry.vertices[7].x,side3Geometry.vertices[7].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);

                side3Geometry.faces.push(new THREE.Face3(4,7,5,new THREE.Vector3(1.0,0.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[4].x,side3Geometry.vertices[4].y),
                    new THREE.Vector2(side3Geometry.vertices[7].x,side3Geometry.vertices[7].y),
                    new THREE.Vector2(side3Geometry.vertices[5].x,side3Geometry.vertices[5].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);





                side3Geometry.faces.push(new THREE.Face3(2,3,9,new THREE.Vector3(0.0,1.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[2].x,side3Geometry.vertices[1].y),
                    new THREE.Vector2(side3Geometry.vertices[3].x,side3Geometry.vertices[3].y),
                    new THREE.Vector2(side3Geometry.vertices[9].x,side3Geometry.vertices[9].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);

                side3Geometry.faces.push(new THREE.Face3(8,5,4,new THREE.Vector3(0.0,1.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[8].x,side3Geometry.vertices[8].y),
                    new THREE.Vector2(side3Geometry.vertices[5].x,side3Geometry.vertices[5].y),
                    new THREE.Vector2(side3Geometry.vertices[4].x,side3Geometry.vertices[4].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);


                const bg3 = new THREE.BufferGeometry().fromGeometry( side3Geometry );

                group.add(new THREE.Mesh(bg3, whiteMat));


                //ВСТАВЛЯЕМ ОКНА
                if(windowModel!==null){
                    wall.objects.map(o=>{
                        if(o.isWindow){
                            const wnd = windowModel.clone();
                            const wndMesh = getMesh(wnd);
                            wndMesh.geometry = wndMesh.geometry.clone();
                            resizeWindow(wnd,o.width/100,o.height/100);

                            const __v = wallVector.clone().setLength(o.width/2 + o.pos)
                            const __x = wall.a.x+__v.x
                            const __z = wall.a.y+__v.y

                            wnd.translateX(__x/100);
                            wnd.translateY((o.heightFromFloor*1 + o.height/2)/ 100);
                            wnd.translateZ(__z/100);
                            wnd.rotateY(angle)
                            wnd.name = 'wallObj'
                            group.add(wnd);
                        }
                    });
                }
                //ВСТАВЛЯЕМ ДВЕРИ
                if(doorModel!==null){
                    wall.objects.map(o=>{
                        if(o.isDoor){
                            const wnd = doorModel.clone();
                            const wndMesh = getMesh(wnd);
                            wndMesh.geometry = wndMesh.geometry.clone();
                            resizeDoor(wnd,o.width/100,o.height/100);

                            const __v = wallVector.clone().setLength(o.width/2 + o.pos)
                            const __x = wall.a.x+__v.x
                            const __z = wall.a.y+__v.y

                            wnd.translateX(__x/100);
                            wnd.translateY((o.heightFromFloor*1 + o.height/2)/ 100);
                            wnd.translateZ(__z/100);
                            wnd.rotateY(angle)
                            wnd.name = 'wallObj'
                            group.add(wnd);
                        }
                    });
                }
                result.add(group);
            });
            // console.log('result',result)
            return result;
        };

        const OLD__generateWalls = (walls)=>{
            const result = new THREE.Group();
            result.name = 'walls';
            walls.map(wall=>{

                // console.log('generateWalls() wall',wall)

                const group = new THREE.Group();
                const wallVector = wall.b.clone().sub(wall.a);
                const angle = -wallVector.angle();
                const center = wall.b.clone().add(wall.a).divideScalar(200);
                const l = wallVector.length();

                const side1Geometry = new THREE.Geometry();
                const [da,db] = getDeltas(plan,wall);
                side1Geometry.vertices.push(new THREE.Vector3(-l/200-da.top/100,0.0,wall.h/200));
                side1Geometry.vertices.push(new THREE.Vector3(-l/200-da.top/100,wall.height/100,wall.h/200));
                side1Geometry.vertices.push(new THREE.Vector3(l/200+db.top/100,0.0,wall.h/200));
                side1Geometry.vertices.push(new THREE.Vector3(l/200+db.top/100,wall.height/100,wall.h/200));

                side1Geometry.faces.push(new THREE.Face3(1,0,2,new THREE.Vector3(0.0,0.0,1.0)));
                let uvs = [
                    new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                    new THREE.Vector2(side1Geometry.vertices[0].x,side1Geometry.vertices[0].y),
                    new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                ];

                side1Geometry.faceVertexUvs[0].push(uvs);
                side1Geometry.faces.push(new THREE.Face3(3,1,2,new THREE.Vector3(0.0,0.0,1.0)));
                uvs = [
                    new THREE.Vector2(side1Geometry.vertices[3].x,side1Geometry.vertices[3].y),
                    new THREE.Vector2(side1Geometry.vertices[1].x,side1Geometry.vertices[1].y),
                    new THREE.Vector2(side1Geometry.vertices[2].x,side1Geometry.vertices[2].y)
                ];
                side1Geometry.faceVertexUvs[0].push(uvs);
                const bg1 = new THREE.BufferGeometry().fromGeometry( side1Geometry.rotateY(angle).translate(center.x,0,center.y) );
/////////////////////////////////////////////////////////////////////////////////////////////////////
                const side2Geometry = new THREE.Geometry();
                side2Geometry.vertices.push(new THREE.Vector3(-l/200-da.bottom/100,0.0,-wall.h/200));
                side2Geometry.vertices.push(new THREE.Vector3(-l/200-da.bottom/100,wall.height/100,-wall.h/200));
                side2Geometry.vertices.push(new THREE.Vector3(l/200+db.bottom/100,0.0,-wall.h/200));
                side2Geometry.vertices.push(new THREE.Vector3(l/200+db.bottom/100,wall.height/100,-wall.h/200));

                side2Geometry.faces.push(new THREE.Face3(0,1,2,new THREE.Vector3(0.0,0.0,1.0)));
                uvs = [
                    new THREE.Vector2(side2Geometry.vertices[0].x,side2Geometry.vertices[0].y),
                    new THREE.Vector2(side2Geometry.vertices[1].x,side2Geometry.vertices[1].y),
                    new THREE.Vector2(side2Geometry.vertices[2].x,side2Geometry.vertices[2].y)
                ];
                side2Geometry.faceVertexUvs[0].push(uvs);

                side2Geometry.faces.push(new THREE.Face3(1,3,2,new THREE.Vector3(0.0,0.0,1.0)));
                uvs = [
                    new THREE.Vector2(side2Geometry.vertices[1].x,side2Geometry.vertices[1].y),
                    new THREE.Vector2(side2Geometry.vertices[3].x,side2Geometry.vertices[3].y),
                    new THREE.Vector2(side2Geometry.vertices[2].x,side2Geometry.vertices[2].y)
                ];
                side2Geometry.faceVertexUvs[0].push(uvs);
                const bg2 = new THREE.BufferGeometry().fromGeometry( side2Geometry.rotateY(angle).translate(center.x,0,center.y) );
//////////////////////////////////////////////////////////////////////////////////////////////////
                const side3Geometry = new THREE.Geometry();
                side3Geometry.vertices.push(new THREE.Vector3(-l/200-da.top/100,0.0,wall.h/200));
                side3Geometry.vertices.push(new THREE.Vector3(-l/200-da.bottom/100,0.0,-wall.h/200));
                side3Geometry.vertices.push(new THREE.Vector3(-l/200-da.top/100,wall.height/100,wall.h/200));
                side3Geometry.vertices.push(new THREE.Vector3(-l/200-da.bottom/100,wall.height/100,-wall.h/200));
                side3Geometry.vertices.push(new THREE.Vector3(l/200+db.top/100,wall.height/100,wall.h/200));
                side3Geometry.vertices.push(new THREE.Vector3(l/200+db.bottom/100,wall.height/100,-wall.h/200));
                side3Geometry.vertices.push(new THREE.Vector3(l/200+db.top/100,0.0,wall.h/200));
                side3Geometry.vertices.push(new THREE.Vector3(l/200+db.bottom/100,0.0,-wall.h/200));


                side3Geometry.faces.push(new THREE.Face3(0,3,1,new THREE.Vector3(-1.0,0.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[0].x,side3Geometry.vertices[0].y),
                    new THREE.Vector2(side3Geometry.vertices[3].x,side3Geometry.vertices[3].y),
                    new THREE.Vector2(side3Geometry.vertices[1].x,side3Geometry.vertices[1].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);

                side3Geometry.faces.push(new THREE.Face3(0,2,3,new THREE.Vector3(-1.0,0.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[0].x,side3Geometry.vertices[0].y),
                    new THREE.Vector2(side3Geometry.vertices[2].x,side3Geometry.vertices[2].y),
                    new THREE.Vector2(side3Geometry.vertices[3].x,side3Geometry.vertices[3].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);

                side3Geometry.faces.push(new THREE.Face3(2,4,3,new THREE.Vector3(0.0,1.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[2].x,side3Geometry.vertices[2].y),
                    new THREE.Vector2(side3Geometry.vertices[4].x,side3Geometry.vertices[4].y),
                    new THREE.Vector2(side3Geometry.vertices[3].x,side3Geometry.vertices[3].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);

                side3Geometry.faces.push(new THREE.Face3(3,4,5,new THREE.Vector3(0.0,1.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[3].x,side3Geometry.vertices[3].y),
                    new THREE.Vector2(side3Geometry.vertices[4].x,side3Geometry.vertices[4].y),
                    new THREE.Vector2(side3Geometry.vertices[5].x,side3Geometry.vertices[5].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);

                side3Geometry.faces.push(new THREE.Face3(4,6,7,new THREE.Vector3(1.0,0.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[4].x,side3Geometry.vertices[4].y),
                    new THREE.Vector2(side3Geometry.vertices[6].x,side3Geometry.vertices[6].y),
                    new THREE.Vector2(side3Geometry.vertices[7].x,side3Geometry.vertices[7].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);

                side3Geometry.faces.push(new THREE.Face3(4,7,5,new THREE.Vector3(1.0,0.0,0.0)));
                uvs = [
                    new THREE.Vector2(side3Geometry.vertices[4].x,side3Geometry.vertices[4].y),
                    new THREE.Vector2(side3Geometry.vertices[7].x,side3Geometry.vertices[7].y),
                    new THREE.Vector2(side3Geometry.vertices[5].x,side3Geometry.vertices[5].y)
                ];
                side3Geometry.faceVertexUvs[0].push(uvs);

                const bg3 = new THREE.BufferGeometry().fromGeometry( side3Geometry.rotateY(angle).translate(center.x,0,center.y) );
                group.add(new THREE.Mesh(bg1,wall.leftSide));
                group.add(new THREE.Mesh(bg2,wall.rightSide));
                group.add(new THREE.Mesh(bg3,new THREE.MeshPhysicalMaterial({color:0x777777})));
                result.add(group);
            });
            return result;
        };

        const init = ()=>{
            camera = new THREE.PerspectiveCamera(
                40, canvas.current.clientWidth/canvas.current.clientHeight, 0.01, 200 );
            camera.position.set(0,25,0);
            scene = new THREE.Scene();
            controls = new OrbitControls( camera, canvas.current );
            controls.maxPolarAngle = Math.PI / 2;
            controls.minDistance = 4;
            controls.maxDistance = 100;
            controls.target = new THREE.Vector3(0,1.4,0);
            controls.update();
            clock = new THREE.Clock();
            raycaster = new THREE.Raycaster();


            renderer = new THREE.WebGLRenderer({
                canvas: canvas.current,
                antialias: true,
                powerPreference: 'high-performance',
                preserveDrawingBuffer: true,
                alpha: true
            });
            renderer.setSize( canvas.current.clientWidth,canvas.current.clientHeight );

            renderer.setClearColor(0x000000, 0)
            renderer.toneMappingExposure = .8
            renderer.physicallyCorrectLights = false

            const GammaEncoding = 3007;
            const PCFSoftShadowMap = 2;
            const ACESFilmicToneMapping = 4;
            renderer.autoClear = true;
            renderer.outputEncoding = GammaEncoding;
            renderer.shadowMap.enabled = true;
            renderer.shadowMap.type = PCFSoftShadowMap;
            renderer.shadowMap.autoUpdate = true;
            renderer.setPixelRatio( window.devicePixelRatio );
            scene.add( new THREE.AmbientLight( 0xffffff, .6 ) );


            const directionalLight = new THREE.DirectionalLight( 0xffffff, .1 );
            directionalLight.position.set( -5, 10, 15 ).normalize();
            scene.add( directionalLight );

            const directionalLight2 = new THREE.DirectionalLight( 0xffffff, .3 );
            directionalLight2.position.set( -10, 10, -10 ).normalize();
            scene.add( directionalLight2 );

            const directionalLight3 = new THREE.DirectionalLight( 0xffffff, .3 );
            directionalLight3.position.set( -10, 10, 10 ).normalize();
            scene.add( directionalLight3 );


            /*
            ambientLight = new THREE.AmbientLight( 0xffffff, 0.8 );
            scene.add( ambientLight );

            const pointLight = new THREE.SpotLight( 0xFFFFFF,0.5);
            spotLight = pointLight;
            pointLight.position.set(0,5,0);
            pointLight.castShadow = false;
            pointLight.distance = 100;
            pointLight.decay = 1;
            pointLight.penumbra = 0.5;
            pointLight.shadow.camera.near = 0.5
            pointLight.shadow.camera.far = 100;
            pointLight.shadow.bias = -0.005;
            pointLight.shadow.radius = 1;
            pointLight.shadow.mapSize = new THREE.Vector2(1024,1024);
            scene.add( pointLight );

             */
/*
            const pointLight = new THREE.SpotLight( 0xFFFFFF,100);
            pointLight.position.set(0,50,0);
            pointLight.castShadow = true;
            pointLight.distance = 100;
            pointLight.decay = 1;
            pointLight.penumbra = 0.5;
            pointLight.shadow.camera.near = 0.5
            pointLight.shadow.camera.far = 100;
            pointLight.shadow.bias = -0.005;
            pointLight.shadow.radius = 1;
            pointLight.shadow.mapSize.width = 2048;
            pointLight.shadow.mapSize.height = 2048;
            scene.add( pointLight );




            var ambientLight =new THREE.AmbientLight( 0x555555, 5.2 );
            scene.add(ambientLight);

            var spotLight = new THREE.SpotLight( 0xffffff, 200);
            spotLight.position.set( 200,56,-200 );
            spotLight.castShadow = true;
            spotLight.shadow.camera.near = 1125;
            spotLight.shadow.camera.far = 1250;
            spotLight.shadow.camera.fov = 130;
            spotLight.shadow.mapSize.width = 2048;
            spotLight.shadow.mapSize.height = 2048;
            scene.add(spotLight);

            var spotLight = new THREE.SpotLight( 0xffffff, 300);
            spotLight.position.set( 300,56,250 );
            spotLight.castShadow = true;
            spotLight.shadow.camera.near = 1125;
            spotLight.shadow.camera.far = 1250;
            spotLight.shadow.camera.fov = 130;
            spotLight.shadow.mapSize.width = 2048;
            spotLight.shadow.mapSize.height = 2048;
            scene.add(spotLight);

            var spotLight = new THREE.DirectionalLight( 0xffffff, 1);
            spotLight.position.set( -5,156,15 );
            spotLight.castShadow = true;
            spotLight.shadow.camera.near = 25;
            spotLight.shadow.camera.far = 150;
            spotLight.shadow.camera.fov = 30;
            spotLight.shadow.mapSize.width = 2048;
            spotLight.shadow.mapSize.height = 2048;
            scene.add(spotLight);
*/

            scene.add(generateFloor(plan,window.materials.floor[0]));
            scene.add(generateWalls(plan.links));
            const modulesGroup = new THREE.Group();
            modulesGroup.name = 'modules';
            modules.map(m=>{
                //modulesGroup.attach(m.model);
                // console.log('TEST ',m);
                const rotateGroup = new THREE.Group();
                const translateGroup = new THREE.Group();
                translateGroup.add(rotateGroup);
                rotateGroup.add(m.model);
                modulesGroup.add(translateGroup);
                translateGroup.position.set(
                    m.position.x/100,
                    0,
                    m.position.y/100
                );
                translateGroup.translateY(m.heightFromFloor*1 / 100)
                rotateGroup.rotation.y = m.angle;
                //modulesGroup.add(new THREE.Mesh(new THREE.BoxBufferGeometry(1,1,1),new THREE.MeshBasicMaterial({color:0xFF0000})));
                //m.model.position.set(m.position.x/100,0,m.position.y/100);
                //m.model.children[0].rotateY(m.angle);
            })
            scene.add(modulesGroup);

            /*
            const sky = new Sky();
            const uniforms = sky.material.uniforms;
            uniforms[ "turbidity" ].value = 10;
            uniforms[ "rayleigh" ].value = 3;
            uniforms[ "mieCoefficient" ].value = 0.005;
            uniforms[ "mieDirectionalG" ].value = 0.8;
            uniforms[ "sunPosition" ].value = new THREE.Vector3(5.0, 20.0, -200.0);
            sky.scale.setScalar( 200);
            scene.add( sky );
            // console.log('SKY ',sky);

            // renderer = new THREE.WebGLRenderer( { antialias: false,canvas: canvas.current} );
            renderer = new THREE.WebGLRenderer( {
                canvas: canvas.current,
                antialias: true,
                powerPreference: 'high-performance',
                preserveDrawingBuffer: true
            } );
            renderer.toneMappingExposure = 1.2
            const GammaEncoding = 3007;
            const PCFSoftShadowMap = 2;
            const ACESFilmicToneMapping = 4;
            renderer.autoClear = true;
            renderer.outputEncoding = GammaEncoding;
            renderer.physicallyCorrectLights = true;
            renderer.setPixelRatio(1); // handle pixel ratio externally
            renderer.shadowMap.enabled = true;
            renderer.shadowMap.type = PCFSoftShadowMap;
            renderer.shadowMap.autoUpdate = false;
            renderer.toneMapping = ACESFilmicToneMapping;

            renderer.setPixelRatio( window.devicePixelRatio );
            // renderer.setClearColor( 0xffffff);
            // renderer.autoClear = false;
            // renderer.shadowMap.enabled = true;
            // renderer.shadowMap.type = THREE.PCFSoftShadowMap;
*/

            raycaster = new THREE.Raycaster();
            mouse = new THREE.Vector2();
            onResize();

            /*
            composer = new EffectComposer(renderer );
            // //this.composer.setSize( this.refs.canvas.clientWidth, this.refs.canvas.clientHeight );
            //
            rp = new RenderPass(scene, camera);
            composer.addPass(rp);
            //
            effectFXAA = new ShaderPass( FXAAShader );
            composer.addPass( effectFXAA );
            //
            saoPass = new SAOPass( scene, camera, false, true );
            composer.addPass( saoPass );
            saoPass.params.saoBias = 0.05;
            saoPass.params.saoBlurRadius = 2;
            saoPass.params.saoIntensity = 0.003;
            saoPass.params.saoKernelRadius = 0.02;

             */
        };

        const animate = ()=>{
            requestAnimationFrame( animate );
            //scene.overrideMaterial = true;
            const mixerUpdateDelta = clock.getDelta();
            modules.map(m=>m.mixer.update(mixerUpdateDelta));
            const camVector = new THREE.Vector3(0,0,-1).applyQuaternion(camera.quaternion).normalize();
            if(camVector.y<-0.5){
                scene.traverse(obj=>{
                    if(obj.isGroup && obj.name==='walls'){
                        obj.traverse(el=>{
                            if(el.isMesh && el.parent.name !== 'wallObj'){
                                el.material.transparent = true;
                                el.material.opacity = 1;
                            } else if(el.isMesh && el.parent.name === 'wallObj'){
                                if (el.material.length>0) {
                                    el.material.map(m=>{
                                        m.transparent = true;
                                        m.opacity = 1;
                                    })
                                } else {
                                    el.material.transparent = true;
                                    el.material.opacity = 1;
                                }
                            }
                        })
                    }
                });
            }
            else{
                scene.traverse(obj=>{
                    if(obj.isGroup && obj.name==='walls'){
                        obj.traverse(el=>{
                            if(el.isMesh && el.parent.name !== 'wallObj'){
                                el.material.transparent = true;
                                el.material.opacity = 0.2;
                            } else if(el.isMesh && el.parent.name === 'wallObj'){
                                if (el.material.length>0) {
                                    el.material.map(m=>{
                                        m.transparent = true;
                                        m.opacity = 0.2;
                                    })
                                } else {
                                    el.material.transparent = true;
                                    el.material.opacity = 0.2;
                                }
                            }
                        })
                    }
                });
            }
            renderer.render(scene, camera);
            // composer.render();
        }

        //ГРУЗИМ МОДЕЛЬ ОКНА
        new THREE.TextureLoader().load('/configurator3d/img/window/white.jpg',texture=>{
            new THREE.TextureLoader().load('/configurator3d/img/window/aomap.png',aomap=>{
                new FBXLoader().load('/configurator3d/img/window/window.fbx',(window)=>{
                    window.traverse(o=>{
                        if(o.isMesh){
                            o.material.map(m=>{
                                if(/glass/.test(m.name)){
                                    m.opacity = 0.4;
                                    m.color = new THREE.Color(0xCCE5FF);
                                    m.map = null;
                                    m.aoMap = null;
                                }
                                else{
                                    m.map = texture;
                                    m.aoMap = aomap;
                                }
                            });
                        }
                    });
                    windowModel = window;
                    // console.log('windowModel',windowModel)
                    scene.add(generateWalls(plan.links));
                });
            });
        });

        new THREE.TextureLoader().load('/configurator3d/img/door/white.jpg',texture=>{
            new THREE.TextureLoader().load('/configurator3d/img/door/aomap.png',aomap=>{
                new FBXLoader().load('/configurator3d/img/door/door.fbx',(door)=>{
                    door.traverse(o=>{
                        if(o.isMesh){
                            o.material.map(m=>{
                                m.map = texture;
                                m.aoMap = aomap;
                                m.aoMapIntensity = 0.3;
                                m.color = new THREE.Color(0xFFFFFF);
                            });
                        }
                    });
                    doorModel = door;
                    // console.log('doorModel',doorModel)
                    scene.add(generateWalls(plan.links));
                });
            });
        });

        const onClickHandler = event=>{
            const rect = canvas.current.getBoundingClientRect();
            let e = event;
            if(event.changedTouches) e = event.changedTouches[ 0 ];
            const mouse = new THREE.Vector2();
            mouse.x = ((e.clientX - rect.left) / rect.width) * 2 - 1;
            mouse.y = -((e.clientY - rect.top) / rect.height) * 2 + 1;
            raycaster.setFromCamera( mouse, camera );
            const _modules = modules.map(m=>m.model);
            const intersects = raycaster.intersectObjects( _modules, true );
            let selectedObject = null;
            if ( intersects.length > 0 ){
                selectedObject = intersects[0].object;
            }
            if(selectedObject){
                const root = modules.find(m=>m.model.getObjectById(selectedObject.id));
                if(root.status === 'close') root.status='open';
                else root.status='close';
            }
            // console.log('SELECTED OBJECT ',selectedObject);
        }
        canvas.current.addEventListener('click',onClickHandler);




        const onMouseWheelHandler = event=>{
            /*
            controls.noZoom = true;
            event.preventDefault();
            const factor = 1;
            const mX = (event.clientX / canvas.current.clientWidth) * 2 - 1;
            const mY = -(event.clientY / canvas.current.clientHeight) * 2 + 1;
            const vector = new THREE.Vector3(mX, mY, 0);
            //console.log(vector);
            vector.unproject(camera);
            vector.sub(camera.position);
            if (event.deltaY < 0) {
                camera.position.addVectors(camera.position,
                    vector.setLength(factor));
                controls.target.addVectors(controls.target,
                    vector.setLength(factor));
                camera.updateProjectionMatrix();
            } else {
                camera.position.subVectors(camera.position,
                    vector.setLength(factor));
                controls.target.subVectors(controls.target,
                    vector.setLength(factor));
                camera.updateProjectionMatrix();
            }
            */
        }
        canvas.current.addEventListener('wheel',onMouseWheelHandler);

        init();
        animate();

        return ()=>{
            window.removeEventListener("resize",onResize);
            canvas.current.removeEventListener('click',onClickHandler);
        }
    },[]);
    return <canvas ref={canvas} id='scene'></canvas>




};

export default ThreeScene;

